import {
  readAgentServiceTranslationMode,
  saveAgentServiceTranslationMode,
} from "../../services/agent-service-language.js";

/** 总客服浮窗的应用级UI开关；不共享订单会话状态，也不模拟任何业务消息事实。 */
export default {
  namespaced: true,
  state: () => ({
    generalOpen: false,
    generalDocked: false,
    generalRequestVersion: 0,
    instanceEpoch: 0,
    translationMode: readAgentServiceTranslationMode(),
  }),
  mutations: {
    /** 在任意页面打开现有总客服窗口，不触发路由跳转或重建会话。 */
    openGeneral(state) {
      state.generalRequestVersion++;
      state.generalOpen = true;
      state.generalDocked = false;
    },
    /** 收纳保留会话生命期，关闭状态不能凭收纳动作自动打开。 */
    setGeneralDocked(state, value) {
      state.generalDocked = state.generalOpen && Boolean(value);
    },
    /** 只有主动关闭或退出当前登录身份时收起。 */
    closeGeneral(state) {
      state.generalOpen = false;
      state.generalDocked = false;
    },
    /** 三个客服入口共享本地展示模式；不修改语言偏好、正文或翻译任务。 */
    setTranslationMode(state, mode) {
      state.translationMode = saveAgentServiceTranslationMode(mode);
    },
    /** 登录身份改变时销毁旧窗口内容；普通切页和主动收起不重建。 */
    resetGeneral(state) {
      state.generalOpen = false;
      state.generalDocked = false;
      state.instanceEpoch += 1;
    },
  },
};
